export enum SigninActions {
  Reset = "Reset",
  Reset_Password = "Reset_Password",
  New_Password = "New_Password",
}
